import React, { useState, useEffect } from "react";
import "@fortawesome/free-regular-svg-icons";
import '../assets/styles/AboutMe.scss';
import { trackSectionView, trackEvent } from '../utils/mixpanel';

function AboutMe() {
    const [isVideoOpen, setIsVideoOpen] = useState(false);

    useEffect(() => {
        trackSectionView('about-me');
    }, []);

    const handleVideoClick = () => {
        setIsVideoOpen(true);
        trackEvent('Video Played', {
            video_title: 'About Me Video',
            video_url: 'https://www.youtube.com/embed/dA0Qq1yi4-8'
        });
    };

    const handleCloseModal = () => {
        setIsVideoOpen(false);
    };


    
    return (
        <div className="container" id="about-me">
            <div className="about-container">
                <h1>About   Me</h1>
                <div className="about-grid">
                    <div className="skill text-section">
                    <p>
    Seasoned Senior Android Engineer with over 6 years of experience in the field, I possess a deep understanding of the mobile development landscape. 
    My expertise lies in Kotlin, the language of choice for modern Android development, while maintaining the ability to work with legacy Java codebases.
</p>

<p>
    I am a strong advocate for the Jetpack suite, utilizing Compose for intuitive UIs, Room for efficient data management, Navigation for a user-friendly experience, 
    and Dagger Hilt for streamlined dependency injection.
</p>

<p>
    Furthermore, I utilize RxJava/Coroutines for robust asynchronous programming and leverage Retrofit to build scalable networking solutions. 
    My commitment to clean and maintainable code is reflected in my implementation of MVVM and MVI design patterns.
</p>

<p>
    An advocate for agile methodologies, I ensure efficient project delivery using Scrum and Kanban while fostering a collaborative environment where I can mentor junior developers 
    and contribute to a culture of best practices.
</p>
                    </div>
                    <div className="skill video-section">
                        <div className="video-container-contact" onClick={handleVideoClick}>
                            <div className="play-button">
                                <span>▶</span>
                            </div>
                            <img 
                                src="http://i3.ytimg.com/vi/dA0Qq1yi4-8/hqdefault.jpg" 
                                alt="Click to play video" 
                                className="video-thumbnail" 
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal for Video */}
            {isVideoOpen && (
                <div className="video-modal-overlay" onClick={handleCloseModal}>
                    <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
                    <iframe 
    width="100%" 
    height="100%" 
    src="https://www.youtube.com/embed/dA0Qq1yi4-8?autoplay=1" 
    title="YouTube video player" 
    frameBorder="0" 
    allow="autoplay; encrypted-media" 
    allowFullScreen
></iframe>
                        <button className="close-button" onClick={handleCloseModal}></button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AboutMe;